import React, {Fragment} from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Alert,
    Row,
    Col,
    Label,
    FormFeedback,
    Input,
    Badge
} from 'reactstrap';

import {Utils, Loading, GestSell, DeleteSell, SellSetting, Params, GestClassroomIndividual} from "custom";
import {ClassroomIndividualAPI, SellAPI, TeacherAPI} from "api";

import {Grid, _} from 'gridjs-react';
import {Link} from "react-router-dom";
import * as XLSX from "xlsx";

const moment = require("moment")

class ListClassroomIndividual extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            classrooms: [],
            teachers: [],
            classroomsFiltered: null,
            loading: true,
            error: false
        };
    }

    componentDidMount() {
        this.getClassroomsIndividual();
        if (Utils.getUserData().role !== "TEACHER")
            this.getTeachers();
    }

    componentWillUnmount() {
        return Params.removeHandlePaginator();
    }

    getClassroomsIndividual() {

        this.setState({loading: true});

        ClassroomIndividualAPI.list().then((classrooms) => {
            this.setState({error: false, classrooms: classrooms, loading: false});
            setTimeout(() => {
                Params.addHandlePaginator()
            }, 1000)
        }).catch(() => {
            this.setState({error: true});
        })
    }

    getTeachers() {
        TeacherAPI.list().then((teachers) => {
            this.setState({teachers: teachers.filter((t) => t.active).map((t) => {
                return {
                    value: t.id,
                    label: t.firstname + " " + t.lastname
                }
            })});
        }).catch(() => {
            this.setState({error: true});
        })
    }


    onFilterSells(filterType, filterConsulent, filterReconfirm, filterStatus) {

        let sells = this.state.sells;

        if (filterConsulent !== null) {
            if (filterConsulent.value === -1) {
                sells = sells.filter((s) => s.consulent === null);
            } else {
                sells = sells.filter((s) => s.consulent?.id === filterConsulent.value);
            }
        }

        if (filterType !== null) {
            if (filterType.value.type === "VIDEO") {
                sells = sells.filter((s) => (filterType.value.id === null) ? s.type === "VIDEO" : (s.type === "VIDEO" && s.course.id === filterType.value.id));
            } else if (filterType.value.type === "CLASSROOM") {
                sells = sells.filter((s) => (filterType.value.id === null) ? s.type === "CLASSROOM" : (s.type === "CLASSROOM" && s.classroom_level.id === filterType.value.id));
            } else if (filterType.value.type === "CLASSROOM_INDIVIDUAL") {
                sells = sells.filter((s) => (filterType.value.id === null) ? s.type === "CLASSROOM_INDIVIDUAL" : (s.type === "CLASSROOM_INDIVIDUAL" && s.classroom_level.id === filterType.value.id));
            }
        }

        if (filterReconfirm !== null) {
            sells = sells.filter((s) => s.reconfirm === filterReconfirm.value);
        }

        if (filterStatus !== null) {
            let val = filterStatus.value;
            switch(val) {
                case 1:
                    sells = sells.filter((s) => s.totalPayed === s.total);
                    break;
                case 2:
                    sells = sells.filter((s) => s.totalPayed < s.total && s.totalPayed > 0);
                    break;
                case 3:
                    sells = sells.filter((s) => s.totalPayed === 0);
                    break;
                default:
                    break;
            }
        }

        if (filterConsulent === null && filterType === null && filterReconfirm === null && filterStatus === null) {
            this.setState({sellsFiltered: null})
        } else {
            this.setState({sellsFiltered: sells})
        }
    }


    render() {

        if (this.state.error) {
            return <React.Fragment>
                <Alert color="danger">Si è verificato un errore durante il recupero della lista classi individuali.</Alert>
            </React.Fragment>
        }

        let classrooms = (this.state.classroomsFiltered !== null) ? this.state.classroomsFiltered : this.state.classrooms

        return <React.Fragment>
            {/*{(typeof this.props.id_client === "undefined") ? <SellSetting onFilterSells={this.onFilterSells.bind(this)} onReload={this.getSells.bind(this)} /> : null}*/}

            {(this.state.loading) ? <Loading/> : <Grid
                data={classrooms}
                columns={[
                    {
                        id: 'id',
                        name: '#',
                        formatter: (cell, row) => _(<div className="text-nowrap text-center">
                            #{cell}
                        </div>)
                    },
                    {
                        id: 'client_id',
                        hidden: true
                    },
                    {
                        id: 'level',
                        hidden: true
                    },
                    {
                        id: 'sell_id',
                        hidden: true
                    },
                    {
                        id: 'date_end',
                        hidden: true
                    },
                    (Utils.getUserData().role !== "TEACHER") ? {
                        id: 'client_name',
                        name: "Cliente",
                        formatter: (cell, row) => _(<div className="text-nowrap text-center">
                            <span className="text-nowrap"><a href="javascript:void(0)" onClick={() => this.props.history.push("/client/" + row.cells[1].data)}><b>{cell}</b></a></span>
                        </div>)
                    } : {
                        id: 'client_name',
                        name: "Cliente",
                        formatter: (cell, row) => _(<div className="text-nowrap text-center">
                            <span className="text-nowrap"><b>{cell}</b></span>
                        </div>)
                    },
                    {
                        id: 'hours',
                        name: "Livello",
                        formatter: (cell, row) => _(<div className="text-nowrap text-center">
                            <span><b>Livello {row.cells[2].data?.name}</b><br /><small>{cell ?? "N/D"} ore</small></span>
                        </div>)
                    },
                    {
                        id: "status",
                        name: "Stato",
                        formatter: (cell, row) => _(<div className="text-nowrap text-center">
                            {(cell === "COMPLETED") ? <Badge color="success">COMPLETATO</Badge> : null}
                            {(cell === "ACTIVE") ? <Badge color="primary">ATTIVA</Badge> : null}
                            {(cell === "WAITING") ? <Badge color="warning">IN ATTESA</Badge> : null}
                            {(cell !== "WAITING") ? <span className="text-nowrap"><br /><a href="javascript:void(0)" onClick={() => this.props.history.push("/classroom/individual/" + row.cells[0].data)}><b>Accedi alla classe</b></a></span> : null}
                        </div>)
                    },
                    (["ADMIN", "CONSULENT"].includes(Utils.getUserData().role)) ? {
                        id: 'status_payment',
                        // Con l'economia su ATOM lo stato del pagamento non arriva (22/10/2026): resta il link all'iscrizione.
                        name: Utils.economiaSuAtom() ? "Iscrizione" : "Stato Pagamento",
                        formatter: (cell, row) => _(<div className="text-nowrap text-center">

                            {(cell === "NOT_PAYED") ? <Badge color="danger">NON PAGATO</Badge> : null}
                            {(cell === "DEPOSIT") ? <Badge color="info">ACCONTO</Badge> : null}
                            {(cell === "PAYED") ? <Badge color="success">SALDATO</Badge> : null}<br />
                            <small className="text-primary cursor-pointer" onClick={() => this.props.history.push("/sell/" + row.cells[3].data)}>Dettaglio Vendita</small>
                        </div>)
                    } : {
                        id: 'status_payment',
                        hidden: true
                    },
                    (Utils.getUserData().role !== "CONSULENT") ? {
                        id: 'consulent',
                        name: "Consulente",
                        formatter: (cell, row) => _(<div className="text-nowrap">
                            <span className="text-nowrap">{(cell !== null) ? cell : "N/D"}</span>
                        </div>)
                    } : {
                        id: 'consulent',
                        hidden: true
                    },
                    (Utils.getUserData().role !== "TEACHER") ? {
                        id: 'teacher',
                        name: "Docente",
                        formatter: (cell, row) => _(<div className="text-nowrap">
                            <span className="text-nowrap cursor-pointer">{(cell !== null) ? <strong>{cell}</strong> : <i>Non Assegnato</i>}</span>
                        </div>)
                    } : {
                        id: 'teacher',
                        hidden: true
                    },
                    {
                        id: "date_start",
                        name: "Date",
                        formatter: (cell, row) => _(<div className="text-nowrap text-center">
                            <span>Inizio: {(cell) ? moment(cell).format("DD MMM YYYY") : "N/D"}</span><br/>
                            <span>Fine: {(cell) ? moment(row.cells[4].data).format("DD MMM YYYY") : "N/D"}</span><br/>
                        </div>)
                    },
                    {
                        id: 'id',
                        name: '',
                        hidden: (!["ADMIN", "CONSULENT", "TEACHER"].includes(Utils.getUserData().role)),
                        sort: false,
                        formatter: (cell, row) => _(<ul
                            className="list-inline hstack gap-2 mb-0">
                            <GestClassroomIndividual teachers={this.state.teachers} preset={classrooms.find((i) => i.id === cell)} onResolve={this.getClassroomsIndividual.bind(this)}/>
                        </ul>)
                    }
                ]}
                sort={true}
                pagination={{enabled: true, limit: 8, page: Params.getActualPage()}}
                search={{
                    selector: (cell, rowIndex, cellIndex) => JSON.stringify(cell)
                }}
                language={{
                    'search': {
                        'placeholder': '🔍 Cerca...'
                    },
                    'pagination': {
                        'previous': 'Indietro',
                        'next': 'Avanti',
                        'showing': 'Stai visualizzando da',
                        'results': 'classi individuali',
                        'to': 'a',
                        'of': 'di',
                    },
                    'noRecordsFound': 'Nessuna classe individuale trovata',
                    'error': 'Si è verificato un errore non previsto',
                }}
            />}
        </React.Fragment>
    }
}

export default ListClassroomIndividual;
